








































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import AbcToolButton from "../button/AbcToolButton.vue";

@Component({
    components: {
        AbcToolButton,
    },
})
export default class AbcPagination extends Vue {
    @Prop({ required: true }) readonly rowsPerPage!: number;
    @Prop({default: 40}) readonly size!: number;
    @Prop({ required: true }) readonly totalcount!: number;
    @Prop() readonly currentPage!: number | null;
    @Prop({ default: 5, validator: (v) => v >= 5}) totalVisible!: number;

    currentPageInner = 1;

    mounted(){
        if(this.totalVisible < 5){
            this.totalVisible = 5;
        }
        if(this.currentPage){
            this.currentPageInner = this.currentPage;
        }
    }

    @Watch("currentPage")
    private onCurrentPageChange() {
        if(this.currentPage){
            this.currentPageInner = this.currentPage;
        }
    }

    @Watch("currentPageInner")
    onChange(newVal: number) {
        this.$emit("pageChanged", {page: newVal, offset: (newVal - 1) * this.rowsPerPage});
    }

    // get maxWidth(){
    //     return {
    //         "width": "" + ((Math.min(this.totalVisible, this.totalPages) + 2) * this.size) + "px"
    //     }
    // }

    get totalPages(): number {
        return Math.ceil(this.totalcount / this.rowsPerPage);
    }

    get pages(): string[] {
        const tot = this.totalPages;

        if (tot <= this.totalVisible) {
            return Array.from(new Array(tot), (val, index) => "" + (index + 1));
        }

        const computedPages: string[] = [];
        const deltaLow = Math.floor(this.totalVisible / 2);
        let deltaUp = deltaLow;
        if((this.totalVisible + 1) % 2){
            deltaUp = deltaLow - 1;
        }

        if (this.currentPageInner < deltaLow || this.currentPageInner > (tot - deltaUp) + 1) {
            computedPages.push(
                ...Array.from(
                    new Array(deltaLow),
                    (val, index) => "" + (index + 1)
                )
            );

            computedPages.push("...");

            computedPages.push(
            ...Array.from(
                new Array(deltaUp),
                (val, index) => "" + (index + 1 + (tot - (deltaUp))))
            )

            return computedPages;
        }

        if(this.currentPageInner === deltaLow ){
            computedPages.push(
                ...Array.from(
                    new Array(this.totalVisible - 2),
                    (val, index) => "" + (index + 1)
                )
            );

            computedPages.push("...");
            computedPages.push("" + tot);
            return computedPages;
        }

        if(this.currentPageInner === (tot - deltaUp) + 1){
            computedPages.push("1");
            computedPages.push("...");

            computedPages.push(
                ...Array.from(
                    new Array(this.totalVisible - 2),
                    (val, index) => "" + (index + 1 + (tot - (this.totalVisible - 2)))
                )
            );
            return computedPages
        }

        computedPages.push("1");
        computedPages.push("...");

        const from = this.currentPageInner - Math.floor((this.totalVisible - 4) / 2);
        const to = this.currentPageInner + Math.ceil((this.totalVisible - 4) / 2);
        computedPages.push(
            ...Array.from(
                new Array(to - from),
                (val, index) => "" + (index + from)
            )
        );

        computedPages.push("...");
        computedPages.push("" + (tot));

        return computedPages;
    }

    handleClick(page: string) {
        switch (page) {
            case "+1":
                if (this.currentPageInner < this.totalPages) {
                    this.currentPageInner++;
                }
                break;
            case "-1":
                if (this.currentPageInner > 1) {
                    this.currentPageInner--;
                }
                break;
            case "...":
                break;
            default:
                this.currentPageInner = parseInt(page);
                break;
        }
    }
}
